const moment = require('moment');

angular
  .module('memberEdit')
  .component('memberEdit', {
    template: require('./member-edit.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', '$routeParams', 'AuthService', 'envService',
      function MemberEditController($rootScope, $scope, $resource, $route, $location, $window, $translate, $routeParams, AuthService, envService) {
        $rootScope.mainmenu = 'members';
        $rootScope.menu = 'users';
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        $resource(`${APIURL}/admin/users/${$routeParams.user_id}`).get((data) => {
          this.user = data.user;
          this.newUser = {};
          this.newUser.NAME = data.user.NAME;
          this.newUser.TEL = data.user.TEL;
          this.newUser.EMAIL = data.user.EMAIL;
          this.newUser.BIRTH = data.user.BIRTH;
          console.log(data);
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });

        this.submit = () => {
          if (this.newUser.NAME.length < 1) {
            alert($translate.instant('이름을 입력해 주세요.'));
            return;
          }
          if (this.newUser.EMAIL.length < 1) {
            alert($translate.instant('이메일을 입력해 주세요.'));
            return;
          }
          if (this.newUser.TEL.length < 1) {
            alert($translate.instant('전화번호를 입력해주세요.'));
            return;
          }

          if (this.newUser.BIRTH && this.newUser.BIRTH.length > 0) {
            if (!moment(this.newUser.BIRTH, 'YYYYMMDD', true).isValid()) {
              alert($translate.instant('올바른 형식의 생년월일이 아닙니다.\n예:19841125(YYYYMMDD)'));
              return;
            }
          }

          if (!confirm($translate.instant('수정하시겠습니까?'))) {
            return;
          }

          $resource(`${APIURL}/admin/users/${this.user.ID}`).save(this.newUser, () => {
            $location.path('/members');
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/member-edit/member-edit.component.js